import styled from 'styled-components';

export const StyledCountdownLogo = styled.img`
    max-width: 612px;

    @media only screen and (max-width: 711px) {
        width: 90%;
    }
`;
